































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  DisciplineOnlineBookingConfig,
  DisciplineOnlineBookingConfigErrorsObject,
} from '@centers/interfaces/online-booking-config';
import { disciplineOnlineBookingConfigFields } from '@/config/online-booking-config';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcMultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import BpcDatepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import BpcInputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import BpcTextarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-discipline-online-booking-config-form',
  components: {
    BpcFormProvider,
    BpcInput,
    BpcMultiSelect,
    BpcDatepicker,
    BpcInputGroup,
    BpcTextarea,
    BpcSwitch,
    BpcEntitySelect,
    BpcSection,
  },
})
export default class DisciplineOnlineBookingConfigForm extends Vue {
  @Prop(Object) readonly value: DisciplineOnlineBookingConfig;
  @Prop(Boolean) readonly enableMultiplayerBooking: boolean;

  get formModel() {
    return this.value;
  }

  set formModel(value: DisciplineOnlineBookingConfig) {
    this.$emit('input', value);
  }

  resetFormModel() {
    this.formModel = {
      allowed_durations: [60],
      max_time_before_booking: '14',
      min_time_before_booking: '0',
      max_number_of_ongoing_upcoming_bookings_when_online_payment: '999',
      max_number_of_ongoing_upcoming_bookings_when_subscription_payment: '999',
      max_number_of_ongoing_bookings_per_week_when_online_payment: '999',
      max_number_of_ongoing_bookings_per_week_when_subscription_payment: '999',
      min_time_between_two_bookings: '12',
      allow_cancel_booking_event: false,
      min_time_before_cancellation: '24',
      min_time_before_player_slot_cancellation: '48',
      reminder_hours_before_cancellation_deadline: null,
      membership_required: false,
      memberships_allow_booking: [],
      automatic_resource_selection: false,
      start_time: '08:00',
      step_duration: 60,
      only_with_subscriptions: 'subscription_only',
    };
  }

  loading = false;
  errorsObject: DisciplineOnlineBookingConfigErrorsObject = {};
  onlineBookingConfig: DisciplineOnlineBookingConfig = null;

  get fieldsConfig() {
    return disciplineOnlineBookingConfigFields;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }

  get usingOnlineBookingV2() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME);
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      this.$set(this.errorsObject, key, errors[key]);
    });
  }

  @Watch('formModel', { deep: true })
  onFormModelChange() {
    this.$emit('formModelChange', this.formModel);
  }
}
